import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b17b4fe")

_pushScopeId("data-v-8b17b4fe")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_backdrop = _resolveComponent("ion-backdrop")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_messages_stream = _resolveComponent("messages-stream")
  const _component_messages_keyboard = _resolveComponent("messages-keyboard")

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode(_component_ion_backdrop, {
          ref: "overlay",
          onClick: _ctx.closeModal
        }, null, 8, ["onClick"]),
        _createVNode("div", {
          tabindex: "0",
          onFocus: _cache[1] || (_cache[1] = (...args) => (_ctx.focusLastDescendant(...args)))
        }, null, 32),
        _createVNode("section", {
          ref: "modalWrapper",
          onKeyupCapture: _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.closeModal(...args)), ["esc"])),
          class: "modal-wrapper ion-overlay-wrapper"
        }, [
          _createVNode("header", _hoisted_2, [
            _createVNode("h2", { textContent: _ctx.title }, null, 8, ["textContent"]),
            _createVNode(_component_ion_button, {
              size: "small",
              fill: "transparent",
              class: "btn-close",
              onClick: _ctx.closeModal
            }, {
              default: _withId(() => [
                _createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: "/assets/icons/close.svg"
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_messages_stream, {
            "message-groups": _ctx.groupedMessages,
            "first-new-group": _ctx.firstNewGroup,
            "out-name": "&pizza HQ",
            "in-name": "Store"
          }, null, 8, ["message-groups", "first-new-group"]),
          _createVNode("footer", null, [
            _createVNode(_component_messages_keyboard, {
              "show-suggestions": false,
              "onSend-message": _ctx.sendHqMessage
            }, null, 8, ["onSend-message"])
          ])
        ], 544),
        _createVNode("div", {
          tabindex: "0",
          onFocus: _cache[3] || (_cache[3] = (...args) => (_ctx.focusFirstDescendant(...args)))
        }, null, 32)
      ], 512), [
        [_vShow, _ctx.isOpen]
      ])
    ]),
    _: 1
  }))
})